import { Observable, tap } from "rxjs";
import { CacheService } from "src/app/services/cache.service";

type InvalidateCacheParams = {
  cacheKeyFactory: (...args: any[]) => string;
};

export function InvalidateCache({
  cacheKeyFactory
}: InvalidateCacheParams): Function {
  return function (
    target: object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...args: any[]) => Observable<any>>
  ): TypedPropertyDescriptor<(...args: any[]) => Observable<any>> {
    if (!descriptor || typeof descriptor.value !== "function") {
      throw new TypeError(
        `Only methods can be decorated with @InvalidateCache. <${propertyKey}> is not a method!`
      );
    }

    const originalValue: (...args: any[]) => Observable<any> = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const originalObs: Observable<any> | Promise<any> = originalValue.apply(
        this,
        args
      );

      const piped = originalObs.pipe(
        tap(() => {
          const cacheKey = cacheKeyFactory.apply(null, args);
          CacheService.instance.delete(CacheService.instance.getKey(cacheKey));
        })
      );

      return piped;
    };

    return descriptor;
  };
}
